import script from "./FacilitiesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./FacilitiesTab.vue?vue&type=script&setup=true&lang=js"

import "./FacilitiesTab.vue?vue&type=style&index=0&id=73365bed&lang=css"

const __exports__ = script;

export default __exports__